export default "__VITE_ASSET__CzuMoG3y__"